/**
 * Options for a picker that links to another record (a vehicle's driver, a
 * movement's vehicle).
 *
 * Archived records should not be offered for a NEW choice, but a record that is
 * already linked must still show by name, not as an empty box, so it stays in
 * the list, marked "(archived)", for as long as it is the current value.
 */
export interface PickerOption {
  value: string;
  label: string;
}

export function pickerOptions<T extends { id: string; archived?: boolean | null }>(
  records: T[],
  currentId: string | null | undefined,
  toLabel: (record: T) => string,
): PickerOption[] {
  return records
    .filter(r => !r.archived || r.id === currentId)
    .map(r => ({ value: r.id, label: r.archived ? `${toLabel(r)} (archived)` : toLabel(r) }));
}
